import HighlightedMessage from "../../../components/HighlightedText";

export function MessageView({
  isMe,
  message,
  isCurrent,
  highlight,
  search,
}: {
  isMe: boolean;
  message: any;
  isCurrent?: boolean;
  highlight?: number | false;
  search?: string;
}) {
  if (isMe) {
    return (
      <>
        <div
          id={message.id}
          className="max-w-[100%] md:max-w-[100%] rounded-md self-start gap-2.5 px-2.5 py-2 flex flex-col"
          style={{
            backgroundColor: ![undefined, false].includes(highlight as any)  ? `#FEF2F2` : "transparent",
          }}
        >
          <div className="justify-start flex">
            <span className="text-right text-xs text-[#2563EB] font-medium">You</span>
          </div>
          <HighlightedMessage 
            message={message.message || message.content}
            searchTerm={search || ""}
            className={`message-content break-word text-text-primary text-sm rounded-l-lg rounded-b-lg border-transparent border-zinc-300 ${
              isCurrent ? "!bg-[#F1ECFC] border-transparent" : ""
            }`}
          />
        </div>
      </>
    );
  }
  return (
    <>
      <div
        id={message.id}
        className="max-w-[100%] md:max-w-[100%] self-start rounded-md px-2.5 py-2 flex-col justify-start items-start gap-1.5 flex"
      >
        <div className="justify-start items-start gap-2.5 flex">
          <span className="text-right text-[#EA580C] font-medium text-xs">{message.name || "Doctor"}</span>
        </div>
        <div className="self-stretch justify-start items-start gap-2 flex">
          <HighlightedMessage
            message={message.message || message.content}
            searchTerm={search || ""}
            className={`message-content break-word rounded-r-lg rounded-b-lg text-text-primary text-sm ${
              isCurrent ? "!bg-[#F1ECFC]" : ""
            }`}
          />
        </div>
      </div>
    </>
  );
}